import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import authService from 'services/auth.service';

export const useResetPassword = (token) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data) => authService.resetPassword(token, data),
    onSuccess: (data) => {
      toast.success(data?.message || 'Password reset successful! Please login with your new password.');
      navigate('/login', { replace: true });
    },
    onError: (error) => {
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to reset password. Please try again.';
      toast.error(errorMessage);
    },
  });
};
